import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 update_tenant_profile_role: { message: "idle" },
};

export const update_tenant_profile_role_Slice = createSlice({
 name: "update_tenant_profile_role",
 initialState,
 reducers: {
  success_update_tenant_profile_role: (state, action) => {
   state.update_tenant_profile_role = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_tenant_profile_role: (state, action) => {
   state.update_tenant_profile_role = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_tenant_profile_role: (state) => {
   state.update_tenant_profile_role = { status: app_consts.IDLE };
  },
  loading_update_tenant_profile_role: (state) => {
   state.update_tenant_profile_role = { status: app_consts.LOADING };
  },
 }
});

export const { success_update_tenant_profile_role, fail_update_tenant_profile_role, reset_update_tenant_profile_role, loading_update_tenant_profile_role } = update_tenant_profile_role_Slice.actions;

export default update_tenant_profile_role_Slice.reducer;